import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";

const API_URL = 'https://backend.aktcorp.com/compliances';

function News() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    //const token = localStorage.getItem("authToken");

    try {
      const response = await axios.get(API_URL);

      const eventList = response.data.data || [];
      setEvents(eventList);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching events:", error);
      setLoading(false);
    }
  };
  return (
    <div className="bg-[#0C2341] min-h-screen mt-3 md:mt-10 mb-10 px-4">
      <Helmet>
        <title>AKT : Compliance</title>
        <meta
          name="description"
          content="AKT Corp works with a concentrated set of leading suppliers bringing the best materials to our client's business needs."
        />
      </Helmet>

      <h1 className="text-4xl font-bold text-center mb-10 text-gray-100 mt-10">
        OUR COMPLIANCE
      </h1>

      {loading ? (
        <div className="flex justify-center items-center min-h-[50vh]">
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 1, ease: "easeInOut" }}
            className="w-16 h-16 border-4 border-t-blue-500 border-b-transparent border-r-transparent border-l-blue-500 rounded-full"
          ></motion.div>
        </div>
      ) : events.length === 0 ? (
        <p className="text-gray-300 text-center text-xl">No Compliance Found.</p>
      ) : (
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 justify-center"
        >
          {events.map((event, index) => (
            <motion.div
              key={event.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white rounded-lg shadow-lg overflow-hidden transform hover:scale-105 transition duration-300 ease-in-out"
            >
              <div className="max-h-80 md:min-h-[490px] w-full flex justify-center items-center h-full">
                <img
                  src={event.imageUrl}
                  alt="Compliance-mage"
                  className="w-full h-full rounded-t-lg object-cover"
                />
              </div>

              {event.pdfUrl && (
                <div className="p-4 text-center">
                  <button
                    onClick={() => navigate(`/view-pdf/${event.id}`, { state: { pdfUrl: event.pdfUrl } })}
                    className="px-6 py-2 w-full flex items-center justify-center gap-2 border-2 border-[#0C2340] text-[#0C2340] hover:text-white hover:bg-[#1B365D] font-semibold rounded-lg transition duration-300"
                  >
                    View PDF
                  </button>
                </div>
              )}
            </motion.div>
          ))}
        </motion.div>
      )}
    </div>
  );
}

export default News;
